import singleSpaCss from 'single-spa-css';
import './tailwind.css';

export * from './index';

const lifecycles = singleSpaCss({
    webpackExtractedCss: true,
    shouldUnmount: false,
    timeout: 10000,
    cssUrls: [],
});

export const { bootstrap, unmount, mount } = lifecycles;
